import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// core components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from "@material-ui/core/Grid";
import GridItem from "../../../views/GridItem";
import GridContainer from "../../../views/GridContainer";
import Table from "../../../views/Table";
import Card from "../../../views/Card";
import CardHeader from "../../../views/CardHeader";
import CardBody from "../../../views/CardBody";
import { withSnackbar } from 'notistack';
import NewWorker from './NewWorker'
import { styles } from './styles';
import ConfirmDialog from './ConfirmDialog'
import Apis from '../../../../utils/Apis'
import Workbook from 'react-excel-workbook'

function formatDate(date){
    var myyear = date.getFullYear(); 
    var mymonth = date.toDateString().split(" ")[1]; 
    var myweekday = date.getDate();
 
    return (myweekday + " " + mymonth + " " + myyear); 
}
function GetWeekDate(){
    var now = new Date(); //��ǰ���� 
    var nowDayOfWeek = now.getDay(); //���챾�ܵĵڼ���
    var nowYear = now.getYear(); //��ǰ�� 
    var nowMonth = now.getMonth(); //�� 
    var nowDay = now.getDate(); //�� 
 
    nowYear += (nowYear < 2000) ? 1900 : 0;
    nowDayOfWeek = nowDayOfWeek==0?7:nowDayOfWeek; // ��������գ��ͱ������

    return {
        thisWeekStartDate: formatDate(new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1)),
        thisWeekEndDate: formatDate(new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek + 1))),
        lastWeekStartDate: formatDate(new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1 - 7)),
        lastWeekEndDate: formatDate(new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek + 1 - 7)))
        };
}

class WorkerManage extends Component {

    state = {
        workers_count: 0,
        pageNumber: 1,
        workers: [],
        temp_page: [],
        export_workers: [],
        isLoading: false,
        open_register: false,
    }

    componentWillMount() {
        const { pageNumber } = this.state;
        this.getWorkers(pageNumber);
    }
    convertMinsToHrsMins = (minutes) => {
        var h = Math.floor(minutes / 60);
        var m = minutes % 60;
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;

        var h_float = Math.round((Math.floor(minutes) / 60) * 100) / 100;
        return h + 'h ' + m + 'min (' + h_float.toFixed(2) + 'h)';
    }
    convertMinsToDayHour = (minutes) => {
        var d = Math.floor(minutes / 480);
        var h = Math.floor(minutes % 480 / 60);
        var _d = h % 8;
        d = d < 0 ? 0 : d;
        _d = _d < 0 ? 0 : h;
        return (d == 0 && _d == 0) ? '0d' : (d + '.' + _d + 'd');
    }
    getWorkers = async (pageNumber) => {
        this.setState({ isLoading: true });
        try {
            this.setState({ isLoading_country_ip: true });
            let response = await Apis.getWorkers();
            let workers = response.data;

            const { classes } = this.props;
            let temp = [];
            let temp_workders = [];
            var index = 0;
            for (let i = 0; i < workers.length; i++) {
                let no = workers[i]['no'];
                let name = workers[i]['name'];
                let lw_hours = this.convertMinsToHrsMins(workers[i]['lastweek_hours']);
                let tw_hours = this.convertMinsToHrsMins(workers[i]['thisweek_hours']);
                let total = this.convertMinsToDayHour(workers[i]['total_hours']);
                temp = [...temp,
                [

                    <Typography noWrap className={classes.typographyContent}>{no}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{name}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{tw_hours}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{lw_hours}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{total}</Typography>,

                ]
                ];
                temp_workders = [
                    ...temp_workders,
                    {No: no, Name: name, 'This Week': tw_hours, 'Last Week': lw_hours, 'Total': total}
                ];
            }

            const { pageNumber } = this.state;
            let temp_page = [];
            temp_page = temp;

            this.setState({ pageNumber: pageNumber, isLoading: false, workers_count: workers.length, workers: temp, temp_page: temp_page, export_workers: temp_workders })


        }
        catch (error) {
            let messageProperty = Object.getOwnPropertyDescriptor(error, 'message');
            this.setState({ isLoading: false });
            this.props.enqueueSnackbar(messageProperty.value, {
                variant: 'error',
            });
        }
    }
    // action for pagination
    handleChangePage = (event, page) => {
        const { pageNumber, workers } = this.state;
        this.setState({
            pageNumber: page + 1,
        });
    }
    createNew = () => {
        const { requesting } = this.props;
        if (requesting) {
            return;
        }
        this.setState({ open_register: true });
    }
    onCloseRegister = () => {
        this.setState({ open_register: false });
    }
    onDoneRegister = () => {
        this.setState({ open_register: false });
        const { pageNumber } = this.state;
        this.getWorkers(pageNumber);
    }
    onAlertMessage = (type, message) => {
        this.props.enqueueSnackbar(message, {
            variant: type,
        });
    }
    render() {
        const { classes } = this.props;
        const { workers_count, pageNumber, temp_page, isLoading, export_workers } = this.state;
        var weekdate = GetWeekDate();
        var workbook_thisweek_label = "This Week (" + weekdate.thisWeekStartDate + "-" + weekdate.thisWeekEndDate + ")";
        var workbook_lastweek_label = "Last Week (" + weekdate.lastWeekStartDate + "-" + weekdate.lastWeekEndDate + ")";
        return (
            <div container>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={classes.cardTitleWhite}>Workers</h4>
                            </CardHeader>
                            <CardBody>
                                <Table
                                    tableHeaderColor="black"
                                    tableHead={[<b>No</b>, <b>Name</b>, <b>{workbook_thisweek_label}</b>, <b>{workbook_lastweek_label}</b>, <b>Total</b>]}
                                    tableData={temp_page}
                                    handleChangePage={this.handleChangePage}
                                    containerHeight={620}
                                    totalCount={temp_page.length}
                                    rowsPerPage={10}
                                    page={pageNumber}
                                    isLoading={isLoading}
                                />
                                <Grid container xs={12} sm={12} md={12}>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={9}>
                                    </Grid>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={1}>
                                        <Workbook filename="workers.xlsx" element={<Button variant="contained" color="primary" className={classes.btnUpdate} disableRipple>Export</Button>}>
                                            <Workbook.Sheet data={export_workers} name="Sheet A">
                                                <Workbook.Column label="No" value="No" />
                                                <Workbook.Column label="Name" value="Name" />
                                                <Workbook.Column label={workbook_lastweek_label} value="Last Week" />
                                                <Workbook.Column label={workbook_thisweek_label} value="This Week" />
                                                <Workbook.Column label="Total" value="Total" />
                                            </Workbook.Sheet>
                                        </Workbook>
                                    </Grid>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={2}>
                                        <Button variant="contained" color="primary" className={classes.btnUpdate} disableRipple onClick={this.createNew}>
                                            New Worker
                                    </Button>
                                    </Grid>
                                </Grid>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <NewWorker
                    onClose={this.onCloseRegister}
                    onAlertMessage={this.onAlertMessage}
                    open={this.state.open_register}
                    onDoneRegister={this.onDoneRegister} />
            </div>
        );
    }
}

WorkerManage.propTypes = {
    classes: PropTypes.object.isRequired
};

let mapStateToProps = (state) => {
    return {
        email: state.auth.email,
        requesting: state.auth.requesting,
    };
}

export default withStyles(styles)(connect(mapStateToProps, null)(withSnackbar(WorkerManage)));
